export const getCookieExpiryTime = () => {
  const now = new Date();
  now.setTime(now.getTime() + (1 * 60 * 60 * 1000)); // 1 hour in milliseconds
  return now.toUTCString();
};

export const setCookie = (name, value, expiryTime, path = "/") => {
  document.cookie = `${name}=${value}; expires=${expiryTime}; path=${path}`;
};

export const clearCookiesArray = (cookiesArray = []) => {
  const expiryTime = new Date(0).toUTCString(); // Set the expiry date to the past
  cookiesArray.forEach(cookie => {
    setCookie(cookie, "", expiryTime);
  });
};

const getGrowpathSelectionState = (form) => {
  const trainingRunInputs = Array.from(form.querySelectorAll('.trainingRun'));
  const requiredGroups = new Set(trainingRunInputs.map((input) => input.name));
  const checkedGroups = new Set(
    Array.from(form.querySelectorAll('.trainingRun:checked')).map((input) => input.name)
  );

  return {
    requiredCount: requiredGroups.size,
    selectedCount: checkedGroups.size,
  };
};

const syncGrowpathSubmitState = () => {
  const forms = Array.from(document.querySelectorAll('form.training-selection__form'));

  if (forms.length === 0) {
    return;
  }

  forms.forEach((form) => {
    const submitButtons = Array.from(form.querySelectorAll('.submit-growpath'));
    if (submitButtons.length === 0) {
      return;
    }

    const { requiredCount, selectedCount } = getGrowpathSelectionState(form);
    const isEnabled = requiredCount > 0 && selectedCount === requiredCount;

    submitButtons.forEach((button) => {
      if (isEnabled) {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
        return;
      }

      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    });
  });
};

const initGrowpathSubmitState = () => {
  const trainingRunInputs = document.querySelectorAll('.trainingRun');

  if (trainingRunInputs.length === 0) {
    return;
  }

  trainingRunInputs.forEach((input) => {
    input.addEventListener('change', () => {
      syncGrowpathSubmitState();
    });
  });

  syncGrowpathSubmitState();
};

// // Function to handle training date selection update
const updateTrainingDateSelection = () => {
  const selectionFields = document.querySelectorAll(".training-selection__training-select");
  const trainingStartDate = Array.from(selectionFields).map(e => e.value);
  
  const offerteField = document.querySelector(".offerte-form input[name='trainingStartDate']");
  if (offerteField) {
      offerteField.value = trainingStartDate.join(", ");
  }
}

// Function to validate the form
const validateForm = (event) => {
  event.preventDefault(); // Prevent the form from submitting
  const errorContainer = document.querySelector('.training-selection__error');
  const selectElements = Array.from(document.querySelectorAll('.training-selection__training-select'));
  const signUpButton = document.querySelector("button[data-signup-link]");
  const signUpString = signUpButton ? signUpButton.getAttribute("data-signup-link") : "inschrijven";
  const signUpTrainingIds = signUpButton ? signUpButton.getAttribute("data-trainingids") : null;
  const signUpPageId = signUpButton ? signUpButton.getAttribute("data-pageid") : null;

  if (selectElements.length === 0 || !signUpButton) {
    return;
  }

  const validTrainingDateSpacing = true; // Replace with actual validation logic if needed
  errorContainer.style.display = !validTrainingDateSpacing ? "flex" : "none";

  if (validTrainingDateSpacing) {
    const expiryTime = getCookieExpiryTime();
    const compoundSelectionString = JSON.stringify(selectElements.map((select) => {
      const selection = select.value;
      const match = selection.match(/\(([^)]+)\)/);
      return match ? match[1] : selection
    } ));

    if (compoundSelectionString && signUpTrainingIds && signUpPageId) {
      setCookie("training-growth__trainingRunIds", compoundSelectionString, expiryTime);
      setCookie("training-growth__trainingIds", signUpTrainingIds, expiryTime);
      setCookie("training-growth__pageId", signUpPageId, expiryTime);
      window.location.href = `${window.location.pathname}/${signUpString}`;
    }
  }
};

// Function to validate the form
const validateForm2 = (event) => {

  var form = event.srcElement;
  event.preventDefault(); // Prevent the form from submitting
  const errorContainer = document.querySelector('.training-selection__error');
  const signUpTrainingRunIds = [form.querySelector("input[name=trainingRunIds]").value];
  const signUpTrainingIds = form.querySelector("input[name=trainingIds]").value;
  const signUpPageId = form.querySelector("input[name=pageId]").value;
  const signUpString = form.querySelector("button[data-signup-link]") ? form.querySelector("button[data-signup-link]").getAttribute("data-signup-link") : "inschrijven";

  const validTrainingDateSpacing = true; // Replace with actual validation logic if needed
  errorContainer.style.display = !validTrainingDateSpacing ? "flex" : "none";

  if (validTrainingDateSpacing) {
    const expiryTime = getCookieExpiryTime();

    const compoundSelectionString = JSON.stringify(signUpTrainingRunIds.map((select) => {
      const selection = select;
      const match = selection.match(/\(([^)]+)\)/);
      return match ? match[1] : selection
    } ));

    if (signUpTrainingRunIds && signUpTrainingIds && signUpPageId) {
      setCookie("training-growth__trainingRunIds", compoundSelectionString, expiryTime);
      setCookie("training-growth__trainingIds", signUpTrainingIds, expiryTime);
      setCookie("training-growth__pageId", signUpPageId, expiryTime);
      window.location.href = `${window.location.pathname}/${signUpString}`;
    }
  }
};

// Function to validate the form
const validateFormGrowpath = (event) => {
  const form = event.currentTarget;
  event.preventDefault(); // Prevent the form from submitting
  const errorContainer = document.querySelector('.training-selection__error');
  const signUpTrainingRunIds = Array.from(form.querySelectorAll('.trainingRun:checked'));
  const signUpTrainingIds = Array.from(form.querySelectorAll('.trainingIds'));
  const signUpPageId = form.querySelector("input[name=pageId]").value;
  const signUpString = form.querySelector("button[data-signup-link]") ? form.querySelector("button[data-signup-link]").getAttribute("data-signup-link") : "inschrijven";

  const requiredTrainingSelections = getGrowpathSelectionState(form).requiredCount;
  const validTrainingDateSpacing = requiredTrainingSelections > 0 && signUpTrainingRunIds.length === requiredTrainingSelections;
  errorContainer.style.display = !validTrainingDateSpacing ? "flex" : "none";

  if (validTrainingDateSpacing) {
    const expiryTime = getCookieExpiryTime();

    const compoundTrainingIdsString = JSON.stringify(signUpTrainingIds.map((select) => {
      const selection = select.value;
      const match = selection.match(/\(([^)]+)\)/);
      return match ? match[1] : selection
    } ));

    const compoundSelectionString = JSON.stringify(signUpTrainingRunIds.map((select) => {
      const selection = select.value;
      const match = selection.match(/\(([^)]+)\)/);
      return match ? match[1] : selection
    } ));

    if (signUpTrainingRunIds && signUpTrainingIds && signUpPageId) {
      setCookie("training-growth__trainingRunIds", compoundSelectionString, expiryTime);
      setCookie("training-growth__trainingIds", compoundTrainingIdsString, expiryTime);
      setCookie("training-growth__pageId", signUpPageId, expiryTime);
      window.location.href = `${window.location.pathname}/${signUpString}`;
    }
  }
};

const animateAccordionCollapse = (panel, duration = 320) => {
  return new Promise((resolve) => {
    if (!panel || panel.classList.contains("hidden")) {
      resolve();
      return;
    }

    const startHeight = panel.scrollHeight;
    panel.style.overflow = "hidden";
    panel.style.height = `${startHeight}px`;
    panel.style.opacity = "1";
    panel.style.transition = `height ${duration}ms ease, opacity ${duration}ms ease`;

    requestAnimationFrame(() => {
      panel.style.height = "0px";
      panel.style.opacity = "0";
    });

    let resolved = false;
    const cleanup = () => {
      if (resolved) return;
      resolved = true;
      panel.style.removeProperty("overflow");
      panel.style.removeProperty("height");
      panel.style.removeProperty("opacity");
      panel.style.removeProperty("transition");
      resolve();
    };

    panel.addEventListener("transitionend", cleanup, { once: true });
    setTimeout(cleanup, duration + 80);
  });
};

const animateAccordionExpand = (panel, duration = 360) => {
  return new Promise((resolve) => {
    if (!panel || panel.classList.contains("hidden")) {
      resolve();
      return;
    }

    panel.style.overflow = "hidden";
    panel.style.height = "0px";
    panel.style.opacity = "0";
    panel.style.transition = `height ${duration}ms ease, opacity ${duration}ms ease`;

    requestAnimationFrame(() => {
      panel.style.height = `${panel.scrollHeight}px`;
      panel.style.opacity = "1";
    });

    let resolved = false;
    const cleanup = () => {
      if (resolved) return;
      resolved = true;
      panel.style.removeProperty("overflow");
      panel.style.removeProperty("height");
      panel.style.removeProperty("opacity");
      panel.style.removeProperty("transition");
      resolve();
    };

    panel.addEventListener("transitionend", cleanup, { once: true });
    setTimeout(cleanup, duration + 80);
  });
};

const slideToNextGrowpath = (trainingElementId) => {
  var trainingId = parseInt(trainingElementId.split("_")[1]);
  var trainingRunId = parseInt(trainingElementId.split("_")[2]);
  var selectedInput = document.getElementById('trainingRun_' + trainingId + '_' + trainingRunId);
  var currentLink = document.getElementById('training_' + trainingId);
  var nextLink = document.getElementById('training_' + (trainingId + 1));
  var currentPanel = document.getElementById('accordion-collapse-body-' + trainingId);
  var nextPanel = document.getElementById('accordion-collapse-body-' + (trainingId + 1));
  var selectedRow = document.getElementById('training-row_' + trainingId + '_' + trainingRunId);
  var selectedContainer = document.getElementById('selectedTrainingRun_' + trainingId);

  if (selectedRow && selectedContainer) {
    selectedContainer.getElementsByClassName('selected-row')[0].innerHTML = selectedRow.innerHTML;
    selectedContainer.classList.remove('hidden');
  }

  // Label onclick can run before the browser toggles the radio; force state first.
  if (selectedInput && !selectedInput.checked) {
    selectedInput.checked = true;
  }
  if (selectedInput) {
    selectedInput.dispatchEvent(new Event('change', { bubbles: true }));
  } else {
    syncGrowpathSubmitState();
  }

  // Run an extra pass after label default behavior and accordion DOM updates.
  requestAnimationFrame(() => {
    syncGrowpathSubmitState();
    setTimeout(syncGrowpathSubmitState, 80);
  });

  animateAccordionCollapse(currentPanel).then(() => {
    if (currentLink && currentPanel && !currentPanel.classList.contains('hidden')) {
      currentLink.click();
    }

    if (nextLink) {
      nextLink.click();
      animateAccordionExpand(nextPanel).then(() => {
        nextLink.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return;
    }

    if (currentLink) {
      currentLink.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGrowpathSubmitState);
} else {
  initGrowpathSubmitState();
}

// Attach the functions to the window object
window.validateForm2 = validateForm2;
window.validateFormGrowpath = validateFormGrowpath;
window.slideToNextGrowpath = slideToNextGrowpath;

// Attach the functions to the window object
window.validateForm = validateForm;
window.updateTrainingDateSelection = updateTrainingDateSelection;